module.exports = __webpack_public_path__ + "static/img/icon-time@2x.75861701.png";